import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=3443aed6&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=3443aed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443aed6",
  null
  
)

export default component.exports